import * as actions from '../../actions/actionTypes';
import initialState from '../initialState';

/**
 * This reducer handles the LOAD_MASTER_DATA_MANAGEMENT_TRS_DATA_SUCCESS & LOAD_MASTER_DATA_MANAGEMENT_TRS_DATA_FAILURE action
 * and sets the property management data to the store
 * @param {Object} [state] The master data management TRS grid data
 * @param {Object} action The action to be handled
 * @returns {Object} The master data management TRS grid data
 */

export default function masterDataManagementTRSReducers(
  state = initialState.trsData,
  action
) {
  if (
    action.type === actions.LOAD_MASTER_DATA_MANAGEMENT_TRS_DATA_SUCCESS &&
    Array.isArray(action.trsData)
  ) {
    return action.trsData;
  } else if (
    action.type === actions.LOAD_MASTER_DATA_MANAGEMENT_TRS_DATA_FAILURE
  ) {
    return initialState.trsData;
  } else {
    return state;
  }
}
